import React, { useState, useEffect, useCallback, useRef } from "react";
import Popover from "@material-ui/core/Popover";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import Utils from "../../Utils";

import {
	Grid,
	Box,
	Typography,
	TextField,
	Button,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { ApplicationDataAPI } from "../../API/ApplicationDataAPI";
import { DocsDataAPI } from "../../API/DocsDataAPI";

const useStyles = makeStyles((theme) => ({
	primaryButton: {
		backgroundColor: "#4053b3!important",
		color: "white!important",
		borderRadius: "3px!important",
		height: "35px!important",
		padding: "10px!important",
		"&:hover": {
			backgroundColor: "#4053b370!important",
		},
	},
}));

export default function ResubmitDetails({
	onClose,
	anchorEl,
	setResubmitEl,
	setUserSubmittedRequest,
	app,
	resubmitDetailsResponse,
}) {
	const open = Boolean(anchorEl);
	const id = open ? "docs-popover" : undefined;

	const classes = useStyles();
	const boxRef = useRef(null);

	const [currentCaseNumber, setCurrentCaseNumber] = React.useState("");
	const [reasons, setReasons] = React.useState(""); //set attachments by case number
	const [documents, setDocuments] = useState([]); // load all documents from app
	const [attachments, setAttachments] = React.useState([]); //set attachments by case number

	const [showHistoryDetails, setShowHistoryDetails] = React.useState(false);
	const [selectedHistoryItem, setSelectedHistoryItem] = React.useState([]);
	const [selectedHistoryAttachments, setSelectedHistoryAttachments] =
		React.useState([]);

	useEffect(() => {
		initializeData();
	}, []);

	const initializeData = async () => {
		if (resubmitDetailsResponse && resubmitDetailsResponse[0]) {
			setReasons(cleanReasons(resubmitDetailsResponse[0].resubmit_reasons));
			setCurrentCaseNumber(resubmitDetailsResponse[0].case_number);

			const fundingChecklistDocuments =
				await DocsDataAPI.fetchApplicationDocumentsById(
					app.id,
					app.broker_id,
					app.locked_by_email
				);

			setDocuments(fundingChecklistDocuments);
		}
	};

	useEffect(() => {
		if (documents) {
			for (const document of documents) {
				if (document.case_number === currentCaseNumber) {
					const newDocument = {
						id: document.id,
						azure_file_url: document.azure_file_url,
						document_name: document.document_name,
					};

					setAttachments((prevAttachments) => [...prevAttachments, newDocument]);
				}
			}
		}
	}, [documents]);

	useEffect(() => {
		if (selectedHistoryItem && selectedHistoryItem.id) {
			for (const document of documents) {
				if (document.case_number === selectedHistoryItem.case_number) {
					const newDocument = {
						id: document.id,
						azure_file_url: document.azure_file_url,
						document_name: document.document_name,
					};

					setSelectedHistoryAttachments((prevAttachments) => [
						...prevAttachments,
						newDocument,
					]);
				}
			}
		}
	}, [selectedHistoryItem]);

	const handleSelectedHistoryItem = (item) => {
		setShowHistoryDetails(true);
		setSelectedHistoryItem(item);
	};

	function cleanReasons(reasons) {
		reasons = reasons.replaceAll("1_", "");
		reasons = reasons.replaceAll("2_", "");
		reasons = reasons.replaceAll("3_", "");
		reasons = reasons.replaceAll("4_", "");
		reasons = reasons.replaceAll("5_", "");
		reasons = reasons.replaceAll(";", ", ");
		return reasons;
	}

	function formatDateTime(dateString) {
		const date = new Date(dateString);

		// Extracting month, date, and year with proper formatting
		const month = date.getMonth() + 1;
		const day = date.getDate();
		const year = date.getFullYear();

		// Formatting time using toLocaleString
		const time = date.toLocaleString("en-US", {
			hour: "numeric",
			minute: "numeric",
			hour12: true,
		});

		// Combining formatted date and time
		const formattedDateTime = `${month}/${day}/${year} - ${time}`;

		return formattedDateTime;
	}

	const downloadFile = async (documentId, azure_file_url, document_name) => {
		try {
			let file_storage_Url = "";
			const containerType = "applications";
			// New method to download the files from Azure File Store
			if (azure_file_url !== undefined) {
				file_storage_Url = await DocsDataAPI.getFileStoreURL(
					azure_file_url,
					containerType
				);
				let link = Utils.urlDownloadfromLink(file_storage_Url, document_name);
				link.click();
				window.URL.revokeObjectURL(link.href);
			} else {
				// Previous method to download the file from Saleforce
				let attachments = await DocsDataAPI.getDocumentAttachment(documentId);
				if (attachments.length > 0) {
					let blob = Utils.base64ToBlob(
						attachments[0].body,
						attachments[0].content_type
					);
					let link = Utils.blobToLink(blob, attachments[0].name);
					link.click();
					window.URL.revokeObjectURL(link.href);
				}
			}
		} catch (e) {
			console.error("Failed to download file");
		}
	};

	const resubmitHeader = () => {
		return (
			<Box style={{ backgroundColor: "#4053b3", height: "80px" }} id="testID">
				<Grid
					container
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: "100%",
					}}>
					<Grid item xs={10}>
						<Typography
							variant="subtitle1"
							style={{
								textAlign: "left",
								fontSize: "20px",
								color: "white",
								paddingLeft: "20px",
							}}>
							Resubmit Details
						</Typography>
					</Grid>
					<Grid
						item
						xs={2}
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}>
						<IconButton
							onClick={() => {
								setResubmitEl(null);
							}}
							style={{ color: "white" }}>
							<CloseIcon style={{ color: "white" }} />
						</IconButton>
					</Grid>
				</Grid>
			</Box>
		);
	};

	const detailsUI = () => {
		return (
			<>
				<Box
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						margin: "20px",
					}}>
					{resubmitDetailsResponse && (
						<>
							{resubmitDetailsResponse[0].resubmit_decision === "Approved" ? (
								<ThumbUpIcon style={{ color: "#72bb53", fontSize: "50px" }} />
							) : (
								<ThumbDownIcon style={{ color: "#e61610", fontSize: "50px" }} />
							)}
							<Typography
								variant="subtitle1"
								style={{
									textAlign: "left",
									fontSize: "20px",
									color:
										resubmitDetailsResponse[0].resubmit_decision === "Approved"
											? "#72bb53"
											: "#e61610",
									paddingLeft: "20px",
								}}>
								{resubmitDetailsResponse[0].resubmit_decision}
							</Typography>
						</>
					)}
				</Box>

				<Grid
					container
					style={{
						display: "flex",
						alignItems: "left",
						justifyContent: "start",
					}}>
					{resubmitDetailsResponse && (
						<>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Date & Time: </strong>{" "}
									{formatDateTime(resubmitDetailsResponse[0].resubmit_decision_date)}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Requested By: </strong>{" "}
									{resubmitDetailsResponse[0].resubmit_requested_by}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Reasons: </strong> {reasons && reasons}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Request Notes: </strong>{" "}
									{resubmitDetailsResponse[0].resubmit_request_notes}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Decisioned By: </strong>{" "}
									{resubmitDetailsResponse[0].resubmit_decision_by}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Analyst Notes: </strong>{" "}
									{resubmitDetailsResponse[0].resubmit_analyst_notes}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Attachments: </strong>{" "}
									{attachments &&
										attachments.map((row) => (
											<>
												<Box
													style={{
														display: "flex",
														alignItems: "center",
														justifyContent: "start",
														color: "#3498db",
														padding: "10px 0px 0px 20px",
													}}>
													<Typography
														style={{ cursor: "pointer" }}
														variant="body"
														onClick={() => {
															downloadFile(row.id, row.azure_file_url, row.document_name);
														}}>
														{row.document_name}
													</Typography>
												</Box>
											</>
										))}
								</Typography>
							</Grid>
						</>
					)}
				</Grid>
			</>
		);
	};

	const historyUI = () => {
		return (
			<>
				<Accordion elevation={0} style={{ backgroundColor: "#f6f6f6" }}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						style={{ paddingLeft: "10px" }}>
						<Typography variant="body2">
							<strong>Resubmit History</strong>
						</Typography>
					</AccordionSummary>
					<AccordionDetails style={{ padding: "4px" }}>
						<TableContainer>
							<Table>
								<TableHead style={{ backgroundColor: "#ebebeb" }}>
									<TableRow>
										<TableCell style={{ padding: "5px", width: "10%" }}>
											<strong>Date</strong>
										</TableCell>
										<TableCell style={{ padding: "5px" }}>
											<strong>Reason(s)</strong>
										</TableCell>
										<TableCell style={{ padding: "5px" }}>
											<strong>Decisioned</strong>
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{resubmitDetailsResponse.slice(1).map((item) => {
										return (
											<TableRow key={item.id}>
												<TableCell style={{ padding: "5px", fontSize: "12px" }}>
													{formatDateTime(item.resubmit_decision_date)}
												</TableCell>
												<TableCell
													style={{
														padding: "5px",
														color: "#3498db",
														cursor: "pointer",
														fontSize: "12px",
													}}
													onClick={() => handleSelectedHistoryItem(item)}>
													{cleanReasons(item.resubmit_reasons).includes(",")
														? `${cleanReasons(item.resubmit_reasons).split(",")[0]} ...`
														: cleanReasons(item.resubmit_reasons)}
												</TableCell>
												<TableCell style={{ padding: "5px", fontSize: "12px" }}>
													{item.resubmit_decision_by}
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
					</AccordionDetails>
				</Accordion>
			</>
		);
	};

	const bottomButtonUI = () => {
		return (
			<>
				<Box
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						margin: "20px",
					}}>
					<Button
						className={classes.primaryButton}
						onClick={() => {
							setUserSubmittedRequest(false);
						}}>
						Create New Resubmit Request
					</Button>
				</Box>
			</>
		);
	};

	//History Details UI
	const historyDetailsUI = (historyItem) => {
		return (
			<>
				<Box
					style={{
						display: "flex",
						height: "40px",
						backgroundColor: "#ebebeb",
						padding: "10px",
						alignItems: "center",
					}}>
					<IconButton
						style={{
							backgroundColor: "lightgray",
							height: "35px",
							width: "35px",
						}}
						onClick={() => {
							setShowHistoryDetails(false);
							setSelectedHistoryItem([]);
							setSelectedHistoryAttachments([]);
						}}>
						<ArrowBackIcon
							style={{
								color: "#4053b3",
								fontSize: "20px",
							}}
						/>
					</IconButton>
					<Typography
						variant="body2"
						style={{
							textAlign: "left",
							color: "black",
							marginLeft: "10px",
						}}>
						<strong>Back</strong>
					</Typography>
				</Box>
				<Box
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						margin: "20px",
					}}>
					{historyItem && (
						<>
							{historyItem.resubmit_decision === "Approved" ? (
								<ThumbUpIcon style={{ color: "#72bb53", fontSize: "50px" }} />
							) : (
								<ThumbDownIcon style={{ color: "#e61610", fontSize: "50px" }} />
							)}
							<Typography
								variant="subtitle1"
								style={{
									textAlign: "left",
									fontSize: "20px",
									color:
										historyItem.resubmit_decision === "Approved" ? "#72bb53" : "#e61610",
									paddingLeft: "20px",
								}}>
								{historyItem.resubmit_decision}
							</Typography>
						</>
					)}
				</Box>

				<Grid
					container
					style={{
						display: "flex",
						alignItems: "left",
						justifyContent: "start",
					}}>
					{historyItem && (
						<>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Date & Time: </strong>{" "}
									{formatDateTime(historyItem.resubmit_decision_date)}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Requested By: </strong> {historyItem.resubmit_requested_by}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Reasons: </strong>{" "}
									{historyItem.resubmit_reasons &&
										cleanReasons(historyItem.resubmit_reasons)}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Request Notes: </strong> {historyItem.resubmit_request_notes}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Decisioned By: </strong> {historyItem.resubmit_decision_by}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Analyst Notes: </strong> {historyItem.resubmit_analyst_notes}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								style={{
									padding: "10px",
									borderTop: "1px solid lightgray",
								}}>
								<Typography
									variant="body2"
									style={{
										textAlign: "left",
										color: "black",
									}}>
									<strong>Attachments: </strong>{" "}
									{selectedHistoryAttachments &&
										selectedHistoryAttachments.map((row) => (
											<>
												<Box
													style={{
														display: "flex",
														alignItems: "center",
														justifyContent: "start",
														color: "#3498db",
														padding: "10px 0px 0px 20px",
													}}>
													<Typography
														style={{ cursor: "pointer" }}
														variant="body"
														onClick={() => {
															downloadFile(row.id, row.azure_file_url, row.document_name);
														}}>
														{row.document_name}
													</Typography>
												</Box>
											</>
										))}
								</Typography>
							</Grid>
						</>
					)}
				</Grid>
			</>
		);
	};

	return (
		<Popover
			id={id}
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "center",
			}}
			classes={{ paper: classes.paper }}
			transformOrigin={{
				vertical: "top",
				horizontal: "center",
			}}
			ref={boxRef}>
			<Box style={{ width: "400px" }}>
				{resubmitHeader()}

				{showHistoryDetails === true ? (
					<Box
						style={{
							padding: "0px",
						}}>
						{historyDetailsUI(selectedHistoryItem)}
					</Box>
				) : (
					<Box
						style={{
							padding: "0px",
						}}>
						{detailsUI()}

						{resubmitDetailsResponse &&
							resubmitDetailsResponse.length >= 2 &&
							historyUI()}

						{bottomButtonUI()}
					</Box>
				)}
			</Box>
		</Popover>
	);
}
